import React from "react";
import blondGirl from "../../assets/girlBlond.png";
import brownGirl from "../../assets/girlBrown.png";
import LazyImage from "./LazyImage";

const BackgroundImages = ({ 
  blondGirlClass = "blondGirl girlBlondMobile", 
  brownGirlClass = "brownGirl girlBrownMobile",
  showBlondGirl = true,
  showBrownGirl = true,
  blondGirlHidden = false,
  brownGirlHidden = false
}) => {
  return (
    <>
      {showBlondGirl && (
        <div className={`${blondGirlClass} ${blondGirlHidden ? 'hiddenGirl' : ''}`}>
          <LazyImage src={blondGirl} alt="" />
        </div>
      )}
      {showBrownGirl && (
        <div className={`${brownGirlClass} ${brownGirlHidden ? 'hiddenGirl' : ''}`}>
          <LazyImage src={brownGirl} alt="" />
        </div>
      )}
    </>
  );
};

export default BackgroundImages;
